"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Card = _styledComponents["default"].div.attrs(function () {
  return {
    id: "info-card"
  };
}).withConfig({
  displayName: "InfoCard__Card",
  componentId: "sc-102lorg-0"
})([""]);

var CardHeader = _styledComponents["default"].div.attrs(function () {
  return {
    className: "card-header"
  };
}).withConfig({
  displayName: "InfoCard__CardHeader",
  componentId: "sc-102lorg-1"
})(["&&&{background:", ";padding:0.25rem 1.25rem;text-align:center;font-size:0.875rem;}"], function (props) {
  return props.theme["white"];
});

var CardBody = _styledComponents["default"].div.attrs(function () {
  return {
    className: "card-body"
  };
}).withConfig({
  displayName: "InfoCard__CardBody",
  componentId: "sc-102lorg-2"
})(["&&&{padding-left:1rem;padding-right:1rem;padding-top:0.75rem;padding-bottom:0.5rem;background:", ";width:", ";height:", ";}"], function (props) {
  return props.backgroundColor || props.theme["light-grey"];
}, function (props) {
  return props.width;
}, function (props) {
  return props.height;
});

var getTitle = function getTitle(title) {
  return title ? _react["default"].createElement(CardHeader, null, title) : null;
};

var InfoCard = function InfoCard(_ref) {
  var width = _ref.width,
      height = _ref.height,
      backgroundColor = _ref.backgroundColor,
      ref = _ref.ref,
      title = _ref.title,
      className = _ref.className,
      children = _ref.children;
  return _react["default"].createElement(Card, {
    className: "card ".concat(className),
    ref: ref
  }, getTitle(title), _react["default"].createElement(CardBody, {
    width: width,
    height: height,
    backgroundColor: backgroundColor
  }, children));
};

InfoCard.defaultProps = {
  className: "",
  width: null,
  height: null,
  backgroundColor: "",
  ref: null
};
InfoCard.propTypes = {
  /** Any Children to display in body of the info card */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node, _propTypes["default"].string]).isRequired,

  /** The title of the card */
  title: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].string]).isRequired,

  /** additional class names to pass */
  className: _propTypes["default"].string,

  /** width of the card */
  width: _propTypes["default"].number,

  /** height of the card */
  height: _propTypes["default"].number,

  /** background color of the card */
  backgroundColor: _propTypes["default"].string,

  /** ref to the card */
  ref: _propTypes["default"].any
};
var _default = InfoCard;
exports["default"] = _default;